import { render, staticRenderFns } from "./IntervalsIndep.vue?vue&type=template&id=1dcba474&"
import script from "./IntervalsIndep.vue?vue&type=script&lang=js&"
export * from "./IntervalsIndep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports